module.exports = __webpack_public_path__ + "static/media/bulk13.e2c0d589.png";